import { ofType } from 'redux-observable';

import { ajax } from 'rxjs/ajax';

import { of } from 'rxjs';

import { map, switchMap, catchError } from 'rxjs/operators';

import {
  UPDATE_PERSONAL_DETAILS,
  UPDATE_PERSONAL_DETAILS_SUCCESS,
  UPDATE_PERSONAL_DETAILS_FAILED,
} from '../../constants';

import { pushModal } from '../../actions/modal-actions';

import store from '../../store';

const updatePersonalDetails = (action$, state$) =>
  action$.pipe(
    ofType(UPDATE_PERSONAL_DETAILS),
    switchMap(action =>
      ajax({
        url: `${state$.value.auth.server}/accounts/${action.accountId}?v=${
          process.env.REACT_APP_VERSION
        }`,
        headers: {
          Authorization: state$.value.auth.token,
        },
        responseType: 'json',
        crossDomain: true,
        body: JSON.stringify(action.payload),
        method: 'PATCH',
      }).pipe(
        map(response => {
          // store.dispatch(fetchAccountOverview());
          return {
            type: UPDATE_PERSONAL_DETAILS_SUCCESS,
            data: response.response,
          };
        }),
        catchError(error => {
          if (error.response.status === 'INCORRECT_CURRENT_PASSWORD') {
            store.dispatch(
              pushModal({
                title: 'Current Password Incorrect',
                message:
                  'You must enter your current password correctly to change your password. No changes have been made.',
              })
            );
          }
          return of({
            type: UPDATE_PERSONAL_DETAILS_FAILED,
            error,
          });
        })
      )
    )
  );

export default updatePersonalDetails;
